import { c as _c } from "react/compiler-runtime";
import React from 'react';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import useProductAR from 'data-hooks/useProductAR';
import useProductAttributes from 'data-hooks/useProductAttributes';
import PDPView3DButtonUI from './PDPView3DButtonUI';
const PDPView3DButton = () => {
  const $ = _c(8);
  const {
    loading,
    data: t0
  } = usePDPBasicDetails();
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const basicDetailsData = t1;
  const {
    name: productName
  } = basicDetailsData;
  const {
    data: t2
  } = useProductAR();
  const {
    arAsset,
    arAssetUpholstery,
    arPrice
  } = t2;
  const {
    data: attributesData
  } = useProductAttributes();
  const t3 = `#callToAction=Close&checkoutTitle=${encodeURIComponent(productName)}`;
  let t4;
  if ($[2] !== arAssetUpholstery || $[3] !== arPrice || $[4] !== t3) {
    t4 = t3.concat(arAssetUpholstery ? `&checkoutSubtitle=${encodeURIComponent(`Shown in ${arAssetUpholstery}`)}` : "", `&price=$${arPrice}`);
    $[2] = arAssetUpholstery;
    $[3] = arPrice;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const banner = t4;
  const url = arAsset ? `${arAsset}${banner}&canonicalWebPageURL=${attributesData?.SEOAttributes?.canonicalURL}&allowsContentScaling=0` : undefined;
  if (loading || !arAsset) {
    return null;
  }
  let t5;
  if ($[6] !== url) {
    t5 = <PDPView3DButtonUI url={url} />;
    $[6] = url;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export default PDPView3DButton;